import { createSelector } from 'reselect'

import { getExpandedNoteIds, getActiveNoteId } from 'data/publicUI/selectors'
import { getAllNotes } from 'data/publicNotes/selectors'

export default function makeMapStateToProps() {
  const getChannelAllNotes = createSelector(
    (state, channelId) => channelId,
    getAllNotes,
    (channelId, allNotes) => {
      return allNotes
        .filter(
          note =>
            note.get('channelId') === channelId &&
            !Boolean(note.get('archivedAt'))
        )
        .toArray()
    }
  )

  return function mapStateToProps(state, { channelId, publicShareToken }) {
    const activeNoteId = getActiveNoteId(state)
    return {
      // Channel properties
      channelId,
      publicShareToken,
      // Notes and positions for items computation
      allChannelNotes: getChannelAllNotes(state, channelId),
      expandedNoteIds: getExpandedNoteIds(state),
      activeNoteId,
    }
  }
}
